export default function OnboardingOverlay({ devData, onComplete }) {
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 200,
      background: "rgba(0,0,0,.65)", backdropFilter: "blur(8px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "1rem",
    }}>
      <div style={{
        background: "var(--bg-card)", borderRadius: 24,
        border: "1px solid var(--border-subtle)",
        padding: "40px 36px", maxWidth: 480, width: "100%",
        boxShadow: "0 32px 80px rgba(0,0,0,.4)",
      }}>
        <h2 style={{ fontSize: 26, fontWeight: 700, color: "var(--text-primary)", letterSpacing: "-.03em", marginBottom: 8 }}>
          Welcome to Ateno
        </h2>
        <p style={{ fontSize: 14, color: "var(--text-muted)", lineHeight: 1.6, marginBottom: 32 }}>
          Your developer account is approved. Here's everything you need to get started.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 32 }}>
          {[
            {
              num: "1",
              title: devData?.hasApiKey ? "Your API key is live" : "Your API key is ready to provision",
              desc: devData?.hasApiKey
                ? "Head to the API Key tab to copy it. Keep it secret and never commit it to version control."
                : "Once your key is generated, it will appear in the API Key tab.",
            },
            {
              num: "2",
              title: "Read the documentation",
              desc: "See available endpoints, request / response schemas, and code examples.",
              link: "/ax",
              linkLabel: "Open docs →",
            },
            {
              num: "3",
              title: "Make your first request",
              desc: "Add the Authorization header and call POST /designs to generate your first room design.",
            },
          ].map((step) => (
            <div key={step.num} style={{
              display: "flex", gap: 14, alignItems: "flex-start",
              background: "var(--bg-elevated)", borderRadius: 14,
              border: "1px solid var(--border-subtle)", padding: "16px 18px",
            }}>
              <div style={{
                minWidth: 28, height: 28, borderRadius: "50%",
                background: "rgba(167,139,250,.18)", border: "1px solid rgba(167,139,250,.3)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 12, fontWeight: 700, color: "#a78bfa",
              }}>{step.num}</div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text-primary)", marginBottom: 4 }}>{step.title}</div>
                <div style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.5 }}>{step.desc}</div>
                {step.link && (
                  <a href={step.link} target="_blank" rel="noopener noreferrer" style={{ fontSize: 13, color: "#a78bfa", textDecoration: "none", marginTop: 6, display: "inline-block" }}>
                    {step.linkLabel}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        <button onClick={onComplete} className="btn btn-white btn-lg" style={{ width: "100%" }}>
          Go to my dashboard
        </button>
      </div>
    </div>
  );
}
